module.exports = __webpack_public_path__ + "img/mysql.bb9ea112.png";